import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import { lockBudgetingScenario } from '../../service/budgetingScenarioService'
import budgetingScenarioQueryKeys from './budgetingScenarioQueryKeys'
import { BudgetingScenario } from '../../types/BudgetingScenario'

export const useLockBudgetingScenario = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const queryClient = useQueryClient()
  const { notification } = App.useApp()
  const { t } = useTranslation()

  if (!companyId) {
    throw new Error('Company ID is required for locking budgeting scenarios.')
  }

  return useMutation({
    mutationKey: budgetingScenarioQueryKeys.list(companyId),
    mutationFn: (scenarioId: BudgetingScenario['id']) => {
      if (scenarioId === null) {
        throw new Error('Cannot lock the default budgeting scenario.')
      }
      return lockBudgetingScenario(companyId, scenarioId)
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: budgetingScenarioQueryKeys.list(companyId) })
      notification.success({ message: t('message:LOCK_SCENARIO_SUCCESS') })
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
